import React from "react"
import Ajax from "../../../Ajax"
import LoginForm from "./LoginForm"
import { LinearProgress } from "@mui/material"
import SsoForm from "./SsoForm"

export default function AuthenticationForms () {

    // Get connection options
    const [loading, setLoading] = React.useState(true)
    const [connectionOptions, setConnectionOptions] = React.useState<string[]>(null)
    const [ssoUrl, setSsoUrl] = React.useState<string>(null)

    const loadOptions = async () => {
        var subdomain = window.location.hostname.split(".")[0]
        if (subdomain.includes("localhost") || subdomain.includes("staging") || subdomain.includes("dev")) {
            
            await Ajax.Session.ConnectionOptions().then((response) => {
                setConnectionOptions(response.data)
            }).catch(() => {
                console.log("There was an error when getting connection options.")
            })
        }

        await Ajax.Session.SsoOptions().then((response) => {
            setSsoUrl(response.data)
        }).catch(() => {
            console.log("There was an error when getting OAuth options.")
        })
    }

    React.useEffect(() => {
        
        loadOptions().then(() => {
            setLoading(false)
        })

    }, [])

    if (loading) return <LoadingAuthenticationOptions />

    if (ssoUrl) return <SsoForm url={ssoUrl} />    

    return (
        <LoginForm connectionOptions={connectionOptions} />
    )
}



function LoadingAuthenticationOptions () {
    return (
        <div style={{width: "300px", display: "grid", gap: "20px"}}>
            <h1 style={{fontSize: "30px"}}>Sign in</h1>
            
            <div>
                <p>Loading options</p>
                <LinearProgress />
            </div>
        </div>
    )
}